/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OrderStatusEnum = 1 | 2 | 3 | 4;

export const OrderStatusEnum = {
    NUMBER_1: 1 as OrderStatusEnum,
    NUMBER_2: 2 as OrderStatusEnum,
    NUMBER_3: 3 as OrderStatusEnum,
    NUMBER_4: 4 as OrderStatusEnum
};

